
























import Vue from 'vue'

export default Vue.extend({
  computed: {
    accountDealerTitle() {
      const dealerTitle = {
        el: `<b>Γιατί να αποκτήσω λογαριασμού εμπόρου;</b>`,
        en: '<b>Why should I get a dealer/ merchant account?</b>'
      }
      return dealerTitle[this.locale]
    },
    accountDealerItem1() {
      const dealerText = {
        el: `Δημιουργώντας τον λογαριασμό εμπόρου αποκτάτε <b>μοναδική "σελίδα εμπόρου"</b> με το όνομά σας, της μορφής <span class="d-site">www.car.gr/emporos</span>, στο οποίο έχετε συγκεντρωμένες όλες τις αγγελίες σας κατηγοριοποιημένες, με τη δυνατότητα να τη μοιράζεστε με τους δυνητικούς πελάτες της επιχείρησής σας.`,
        en:
          'By creating the merchant page, you get a unique “merchant page” with your name, the form <span class="d-site">www.car.gr/emporos</span>, in which you can gather and categorize all of your classifieds, with the opportunity to share them with your potential customers.'
      }
      return dealerText[this.locale]
    },
    accountDealerItem2() {
      const dealerText = {
        el: `Συμπεριλαμβάνεται η επιχείρησή σας στον <b>χάρτη εμπόρων</b> και έτσι οι επισκέπτες της σελίδας μας γνωρίζουν που μπορούν να σας βρουν αλλά και τα προϊόντα και τις υπηρεσίες τις οποίες διαθέτετε. <b>Βελτιώνετε τις πωλήσεις σας</b> καθώς οι χρήστες σας εμπιστεύονται ευκολότερα λόγω του ότι εμπιστεύονται το <a href="https://car.gr" title="Car.gr">Car.gr</a> εδώ και 20 χρόνια.`,
        en:
          'Your company will be added to the <b>merchants’ map</b>, so the visitors of the page will know where to find you, the products and the services you offer.<b> You will improve your sales</b> as your users will trust you more easily because Car.gr has built the buyers trust for 20 whole years by not allowing scams to happen.'
      }
      return dealerText[this.locale]
    },
    accountDealerItem3() {
      const dealerText = {
        el: `Κάθε μέρα λαμβάνετε <b>200credits Δωρεάν</b> τα οποία μπορείτε να τα εκμεταλλευτείτε για να φέρετε τις αγγελίες σας πρώτες στα αποτελέσματα αναζήτησης.`,
        en:
          'Every day you will receive <b>200 free credits</b> which you can take advantage of by bringing your classifieds to the top of the search results.'
      }
      return dealerText[this.locale]
    },
    accountDealerItem4() {
      const dealerText = {
        el: `Έχετε την <b>δυνατότητα μαζικών ανανεώσεων</b> των αγγελιών σας και <b>μαζική επεξεργασία των τιμών</b> σας χωρίς να χρειάζεται να κάνετε 1 προς 1 τις αγγελίες σας ανανέωση.`,
        en:
          'You will have the ability to mass upgrade your classifieds and mass edit the price of them. So, you don’t have to do them one by one.'
      }
      return dealerText[this.locale]
    },
    accountDealerItem5() {
      const dealerText = {
        el: `Έχετε τη δυνατότητα να ανεβάσετε <b>"Αυτόματα"</b> στο <a href="https://car.gr" title="Car.gr">Car.gr</a> όσες αγγελίες επιθυμείτε <b>μέσω xml</b>, χωρίς να χρειάζεται να τις ανεβάζετε 1 προς 1. Οι αγγελίες σας ενημερώνονται αυτόματα!`,
        en:
          'You will have the ability to <b>“Automatically”</b> upload to <a href="https://car.gr" title="Car.gr">Car.gr</a> as many classifieds as you wish <b>via XML</b>, without having to upload them one by one.'
      }
      return dealerText[this.locale]
    },
    accountDealerItem6() {
      const dealerText = {
        el: `Μπορείτε να προσθέσετε σε κάθε αγγελία σας το <b>link προς την ιστοσελίδα σας</b> ώστε να πραγματοποιήσει κάποιος χρήστης <b>"Online Αγορά"</b> από το κατάστημά σας.`,
        en:
          'You can add your website link in the owned classifieds, so users can buy from your online store.'
      }
      return dealerText[this.locale]
    },
    accountDealerItem7() {
      const dealerText = {
        el: `Έχετε <b>συγκεντρωμένα όλα τα μηνύματα σας</b> για όλες τις αγγελίες σας σε ένα σημείο και έτσι μπορείτε να επικοινωνείτε με όσους ενδιαφέρονται για τα προϊόντα ή τις υπηρεσίες σας. Τα μηνύματά σας δεν χάνονται ακόμη και για παλιές αγγελίες και ενημερώνεστε καθημερινά στο email σας.`,
        en:
          'You will have a <b>complete massaging center</b> and no mail will be lost over time.'
      }
      return dealerText[this.locale]
    },
    accountDealerItem8() {
      const dealerText = {
        el: `Μπορείτε να κάνετε <b>επαναφορά διαγραμμένων αγγελιών</b> και να τις εμφανίσετε και πάλι διαθέσιμες.`,
        en:
          'You will be able to <b>restore deleted classifieds</b> and make them available again.'
      }
      return dealerText[this.locale]
    },
    accountDealerItem9() {
      const dealerText = {
        el: `Μπορείτε να <b>προσθέσετε τα Social Media</b> της επιχείρησής σας ώστε να προωθήσετε επιπλέον επισκέπτες σε αυτά.`,
        en:
          'You can add your <b>social media accounts</b> for additional visitors.'
      }
      return dealerText[this.locale]
    },
    accountDealerItem10() {
      const dealerText = {
        el: `Λαμβάνετε <b>πολύτιμα στατιστικά για τις αγγελίες σας</b> καθώς επίσης έχετε τη δυνατότητα να συνδέσετε τις αγγελίες σας με τα στατιστικά της ιστοσελίδα σας στο Google Analytics.`,
        en:
          'You will receive <b>statistics</b> for your classifieds, and you can view them and the website via Google Analytics.'
      }
      return dealerText[this.locale]
    },
    accountDealerItem11() {
      const dealerText = {
        el: `Οι χρήστες οι οποίοι κάνουν συγκεκριμένες αναζητήσεις στα φίλτρα έχουν τη <b>δυνατότητα να δουν τα καταστήματα</b> τα οποία διαθέτουν το προϊόν που επιθυμούν και εκεί <b>εμφανίζονται συγκεντρωμένες όλες οι αγγελίες</b> της επιχείρησής σας.`,
        en:
          'With a specific search, users will be viewed stores with that exact product, all the <b>products of your store will be viewed</b> there.'
      }
      return dealerText[this.locale]
    },
    accountDealerItem12() {
      const dealerText = {
        el: `Στους χρήστες οι οποίοι βλέπουν κάποια συγκεκριμένη αγγελία της επιχείρησής σας, παράλληλα εμφανίζεται η ενότητα <b>"Αγγελίες Εμπόρου"</b> με παρόμοιες αγγελίες της επιχείρησής σας, ώστε να βελτιστοποιείται η επισκεψιμότητα στις αγγελίες σας.`,
        en:
          'To the users who see a specific classified of you, there will be a section <b>“Merchant Classifieds”</b> to link them to all the owned classifieds.'
      }
      return dealerText[this.locale]
    },
    commercialTitle() {
      const cTitle = {
        el: '<b>Σε εμπορικό επίπεδο:</b>',
        en: '<b>From a Commercial Perspective:</b>'
      }
      return cTitle[this.locale]
    },
    commercialTextItem1() {
      const cText = {
        el: `Μπορείτε να <b>καταχωρείτε</b> αλλά και να <b>βλέπετε αγγελίες εμπόρων</b> οι οποίες απευθύνονται αποκλειστικά σε εμπόρους (π.χ. με τιμή χονδρικής) καθώς και να αναπτύσσετε επιχειρηματικές συνεργασίες.`,
        en:
          'You can upload and see classifieds of other merchants and improve business partnerships.'
      }
      return cText[this.locale]
    },
    commercialTextItem2() {
      const cText = {
        el: `Μπορείτε να βλέπετε <b>αγγελίες εμπόρων</b> προερχόμενες <b>από το εξωτερικό</b> αναπτύσσοντας το δίκτυο των συνεργατών σας.`,
        en:
          'Observe <b>classifieds of foreign merchants</b> developing your partner network.'
      }
      return cText[this.locale]
    },
    commercialTextItem3() {
      const cText = {
        el: `Έχετε τη δυνατότητα να βλέπετε την <b>εξέλιξη τιμής της κάθε αγγελίας</b> και έτσι να κλείνετε τις πιο συμφέρουσες συμφωνίες.`,
        en: 'Observation availability of price change in every classified.'
      }
      return cText[this.locale]
    },
    commercialTextItem4() {
      const cText = {
        el:
          '<b>Λαμβάνετε ειδοποιήσεις</b> ώστε να ανανεώνετε τις αγγελίες σας και με αυτόν τον τρόπο να αποκτούν περισσότερες προβολές.',
        en:
          'You receive notifications to update your classifieds to <b>get more views.</b>'
      }
      return cText[this.locale]
    },
    commercialTextItem5() {
      const cText = {
        el:
          'Έχετε τη δυνατότητα να προσφέρετε,<b>διαφορετικούς τρόπους χρηματοδότησης</b>. Μπορείτε να ορίσετε το επιτόκιο(%), τις μέγιστες δόσεις αλλά και την ελάχιστη προκαταβολή και έτσι να προσφέρετε ένα <b>ανταγωνιστικό πλεονέκτημα στις αγγελίες σας</b>.',
        en:
          'You can set your rate of interest, maximum installment and minimum deposit giving an extra advantage to your classifieds.'
      }
      return cText[this.locale]
    },
    commercialTextItem6() {
      const cText = {
        el: `Μπορείτε να προσθέσετε <b>περισσότερες φωτογραφίες</b> από τους υπόλοιπους χρήστες και έτσι να δώσετε μια ακόμη πιο ολοκληρωμένη εικόνα των αγγελιών σας.`,
        en: 'Add <b>more photos</b> than your competitors for more views.'
      }
      return cText[this.locale]
    },
    accountDealerTextArray() {
      return [
        this.accountDealerItem1,
        this.accountDealerItem2,
        this.accountDealerItem3,
        this.accountDealerItem4,
        this.accountDealerItem5,
        this.accountDealerItem6,
        this.accountDealerItem7,
        this.accountDealerItem8,
        this.accountDealerItem9,
        this.accountDealerItem10,
        this.accountDealerItem11,
        this.accountDealerItem12
      ]
    },
    commercialTextArray() {
      return [
        this.commercialTextItem1,
        this.commercialTextItem2,
        this.commercialTextItem3,
        this.commercialTextItem4,
        this.commercialTextItem5,
        this.commercialTextItem6
      ]
    },

    locale(): string {
      return this.$i18n.locale
    }
  }
})
